import { ElementRef, Injectable } from '@angular/core';
import { qq } from 'fine-uploader/lib/core/azure';
import * as Enumerable from 'linq';

@Injectable({
  providedIn: 'root'
})
export class UploaderService {
  public UploadFilesButton: ElementRef;
  public UploadImageButton: ElementRef;
  public UploadAllTypesButton: ElementRef;
  public Uploader: qq.azure.FineUploaderBasic;
  public DragAndDrop: qq.DragAndDrop;
  private dragAndDropZones = [];
  private qq: qq;

  constructor() { }

  public BrowseFiles(data: any, metadata: any = null) {
    this.Uploader.setParams(data);
    this.Uploader.jms = data;
    this.Uploader.metadata = metadata;
    this.UploadFilesButton.nativeElement.querySelector('input').click();
  }

  public BrowseImages(data: any, metadata: any = null) {
    this.Uploader.setParams(data);
    this.Uploader.jms = data;
    this.Uploader.metadata = metadata;
    this.UploadImageButton.nativeElement.querySelector('input').click();
  }

  public BrowseAllTypes(data: any, metadata: any = null) {
    this.Uploader.setParams(data);
    this.Uploader.jms = data;
    this.Uploader.metadata = metadata;
    this.UploadAllTypesButton.nativeElement.querySelector('input').click();
  }

  public setupExtraDropzone(dropZone: any, allowedExtensions: string[], callback: () => any) {
    this.dragAndDropZones.push({
      dropZone: dropZone,
      callback: callback,
      allowedExtensions: allowedExtensions
    });
    this.DragAndDrop.setupExtraDropzone(dropZone);
  }

  public removeDropzone(dropZone: any) {
    if (!this.DragAndDrop) return;
    const index = Enumerable.from(this.dragAndDropZones).indexOf(p => p.dropZone === dropZone);
    if (index > -1) {
      this.dragAndDropZones.splice(index, 1);
    }
    this.DragAndDrop.removeDropzone(dropZone);
  }

  public dropFiles(files: any[], dropZone) {
    const element = Enumerable.from(this.dragAndDropZones).firstOrDefault(p => p.dropZone === dropZone);
    if (element) {
      const result = element.callback();
      this.Uploader.setParams(result);
      this.Uploader.jms = result;
    }
    const filesUpload = Enumerable.from(files)
      .where(p => this.isAllowedExtension(element.allowedExtensions, p.name))
      .toArray();
    if (filesUpload.length > 0) this.Uploader.addFiles(filesUpload);
  }

  isAllowedExtension(allowed: string[], fileName) {
    let valid = false;
    if (!allowed.length) {
      return true;
    }
    allowed.forEach(p => {
      const extRegex = new RegExp('\\.' + p + '$', 'i');
      if (fileName.match(extRegex) != null) {
        valid = true;
        return valid;
      }
    });

    return valid;
  }

  public uploadDropFile(file: any, data: any, metadata: any) {
    this.Uploader.setParams(data);
    this.Uploader.jms = data;
    this.Uploader.metadata = metadata;
    this.Uploader.addFiles(file);
  }

  public uploadBase64(file: any, metadata: any): void {
    const data = {
      entityid: '',
      entityname: 'Signature',
      type: 'Image'
    };

    this.Uploader.setParams(data);
    this.Uploader.jms = data;
    this.Uploader.metadata = metadata;
    this.Uploader.addFiles(file);
  }
}
